// extracted by mini-css-extract-plugin
export var dropdown = "dropdown-module--dropdown--NbsHw";
export var opened = "dropdown-module--opened--otyNW";
export var triangle = "dropdown-module--triangle--43+Tf";